import { tr } from '../utils/e7n-util';

type Feature = {
  name: string;
  premium: boolean;
  enterprise: boolean;
  url?: string;
};

const FEATURES: Feature[] = [
  {
    name: tr('Image cropping'),
    premium: true,
    enterprise: true,
  },
  {
    name: tr('Date & timestamp'),
    premium: true,
    enterprise: true,
  },
  {
    name: tr('Annotations: blur, text, highlight'),
    premium: true,
    enterprise: true,
  },
  {
    name: tr('Guaranteed capture'),
    premium: false,
    enterprise: true,
  },
  {
    name: tr('Multi-user accounts'),
    premium: false,
    enterprise: true,
  },
  {
    name: tr('Group demo and webinar'),
    premium: false,
    enterprise: true,
  },

  {
    name: tr('Security audit'),
    premium: false,
    enterprise: true,
    url: 'https://blog.gofullpage.com/2025/07/15/how-to-safely-screenshot-webpages-in-high-security-environments/',
  },
];

const data = {
  features: FEATURES,
};

export default data;
